import { render, staticRenderFns } from "./aLteLayoutPage.vue?vue&type=template&id=60cdee5a"
var script = {}
import style0 from "./aLteLayoutPage.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('60cdee5a', component.options)
    } else {
      api.reload('60cdee5a', component.options)
    }
    module.hot.accept("./aLteLayoutPage.vue?vue&type=template&id=60cdee5a", function () {
      api.rerender('60cdee5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/aLteLayoutPage.vue"
export default component.exports